$(() => {
  const key = 'disable-on-empty';

  $(`[data-${key}]`).each(function () {
    const target = $(this);
    const inputs = $(target.data(key));
    inputs.on('input', function () {
      const isEmpty =
        inputs.filter(function () {
          return (
            ($(this).prop('type') === 'checkbox' && $(this).prop('checked')) ||
            ($(this).prop('type') !== 'checkbox' && !!$(this).val())
          );
        }).length === 0;

      target.prop('disabled', isEmpty);
    });
  });
});
